import type { SortDirection } from '@tanstack/react-table';

import ActiveSortIcon from './active-sort-icon.svg?react';
import InactiveSortIcon from './inactive-sort-icon.svg?react';

type Props = {
  active?: boolean;
  direction: SortDirection;
};

export const SortLabelIcon = ({ active, direction }: Props) => {
  if (!active) {
    return <InactiveSortIcon />;
  }

  return (
    <ActiveSortIcon
      style={{ transform: direction === 'desc' ? 'scaleY(-1)' : '' }}
    />
  );
};
